// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6df3a52","466":"f0ed4040","522":"141661c3"}[chunkId] + ".chunk.js";
};